const enrollmentCompleteSX = {
    pageContainer: {
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    contentBox: {
        width: { xs: "90%", md: "50%", lg: "50%" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    statusBox: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
        p: 4,
        border: "1px solid",
        borderColor: "primary.main",
        borderRadius: "8px",
        bgcolor: "primary.100",
    },
    pendingIcon: {
        fontSize: { xs: "50px", md: "80px" },
    },
    successIcon: {
        fontSize: { xs: "80px", md: "80px" },
    },
    errorIcon: {
        fontSize: "96px",
    },
    pendingTitle: {
        fontSize: { xs: "22px", md: "32px" },
        fontWeight: "bold",
        mt: 4,
    },
    successTitle: {
        fontSize: { xs: "22px", md: "28px" },
        fontWeight: "bold",
        mt: 4,
    },
    pendingText: {
        fontSize: { xs: "16px", md: "24px" },
        fontWeight: 500,
        textAlign: "center",
    },
    successText: {
        fontSize: { xs: "16px", md: "22px" },
        fontWeight: 500,
    },
    errorText: {
        fontSize: "24px",
        fontWeight: 500,
        textAlign: "center",
    },
    button: {
        mt: 2,
        borderRadius: "5px",
    },
    loaderBox: {
        height: "80vh",
    },
    successInfoBox: {
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        gap: 5,
    },
};

export default enrollmentCompleteSX;
